var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('image-entity-info-tooltip');
import { breakpoints } from '@shapeable/theme';
import { InfoCircleFilledIcon } from '../icons/info-circle-filled-icon';
import { Icon } from '../elements/icon';
import ReactTooltip from 'react-tooltip';
export var ImageEntityInfoTooltipDefaultProps = {
  opacity: 0.5,
  size: 20,
  color: 'light',
  icon: InfoCircleFilledIcon,
  event: 'click',
  backgroundColor: '#FFFFFF',
  textColor: '#444444'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    cursor: pointer;\n\n    ", "\n\n    &:hover {\n      opacity: 1.0;\n    }\n  "], ["\n    cursor: pointer;\n\n    ", "\n\n    &:hover {\n      opacity: 1.0;\n    }\n  "])), function (_a) {
    var opacity = _a.opacity;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      opacity: ", ";\n    "], ["\n      opacity: ", ";\n    "])), opacity);
  })
}); // -------- Components -------->

var My = {
  Container: styled(Icon)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var ImageEntityInfoTooltip = function ImageEntityInfoTooltip(props) {
  var _a;

  var className = props.className,
      entity = props.entity,
      opacity = props.opacity,
      event = props.event,
      backgroundColor = props.backgroundColor,
      textColor = props.textColor,
      iconProps = __rest(props, ["className", "entity", "opacity", "event", "backgroundColor", "textColor"]);

  var textDescription = entity && entity.description && entity.description.text;
  var htmlDescription = entity && entity.description && entity.description.html;
  React.useEffect(function () {
    ReactTooltip.rebuild();
  });
  var Icon = props.icon; // favour html description 

  var description = htmlDescription || textDescription;
  var isHtml = !!htmlDescription;
  var tooltipProps = description && (_a = {}, _a['data-event'] = event, _a['data-tip'] = description, _a['data-html'] = isHtml, _a['data-class'] = cls.sub('tooltip'), _a['data-background-color'] = backgroundColor, _a['data-text-color'] = textColor, _a);

  if (!description) {
    return null;
  }

  return React.createElement(My.Container, __assign({
    opacity: opacity
  }, tooltipProps, iconProps, {
    className: cls.name(className)
  }), React.createElement(Icon, null));
};
ImageEntityInfoTooltip.defaultProps = ImageEntityInfoTooltipDefaultProps;
ImageEntityInfoTooltip.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;